import ResizeObserver from "resize-observer-polyfill";
import store from "@/store";

const ro = new ResizeObserver(entries => {
  for (const entry of entries) {
    const { width } = entry.contentRect;
    // console.log(entry);
    // console.log("Element:", entry.target);
    // console.log("Element id:", entry.target.id);
    // console.log(`Element's size: ${width}px x ${height}px`);
    // console.log(`Element's paddings: ${top}px ; ${left}px`);
    // console.log(store.state.listWidth[entry.target.id]);
    // store.state.listWidth[entry.target.id] = parseInt(width);
    store.commit("setListWidth", parseInt(width));
    //在此处做你要做的事情，例如我得到了header的自身的高度，然后设置Drawer的margin-top为这个高度，那么，无论header如果变化，我的drawer都会紧紧吸附于header了
  }
});

export function resizeObserver(ele) {
  ro.observe(ele);
}
